import React from 'react'
import { Link } from 'react-router-dom'
import { logo } from 'assets'

const Header = () => {
  return (
    <div style={{
      padding: '1rem 10rem',
      boxShadow: '0px 0px 12px 10px rgba(171,171,171,0.25)',
      backgroundColor: 'white',
      // position: 'sticky',
      // top: 0,
      // zIndex: 1000,
    }}>
      <Link to='/'>
        <img alt='logo' src={logo} style={{ height: '3.5rem' }} />
      </Link>
    </div>
  )
}

export default Header
